import { useTranslation } from "react-i18next";
import { PageSelectionButton } from "../PageSelectionButton/PageSelectionButton";
import { getImage } from "../../services/ImageService";

export function ResourcePageSelection() {
    const { t } = useTranslation();

    return (
        <div className="group flex items-center items-center cursor-pointer select-none h-full">
            <div className="text-base font-bold text-pine w-full h-full flex gap-2 items-center z-20 gap-3 h-[50px] rounded-full group-hover:bg-[rgba(36,45,41,0.05)] md:px-12">
                {t("resources")}
                <div className="w-4 mt-1">
                    <img
                        src={getImage("gui/menu-down-pine.svg")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute flex-col bg-white z-10 w-max top-32 select-none overflow-y-auto shadow-2xl rounded-3xl">
                <PageSelectionButton
                    content={t("guides")}
                    target="guides"
                />
                <PageSelectionButton
                    content={t("manual")}
                    target="manual/introduction"
                />
                <PageSelectionButton
                    content={t("manual-prerequisites")}
                    target="manual/prerequisites"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("manual-basics")}
                    target="manual/basics"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("manual-forest-management-planning")}
                    target="manual/forest-management-planning"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("manual-action-planning")}
                    target="manual/action-planning"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("manual-drone-operations")}
                    target="manual/drone-operations"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("manual-advanced")}
                    target="manual/advanced"
                    className="pl-24"
                />
                <PageSelectionButton
                    content={t("api")}
                    target="api"
                />
                <PageSelectionButton
                    content={t("faq")}
                    target="faq"
                />
            </div>
        </div>
    );
}
